import { Dropdown, Menu, message, notification, PageHeader, Popconfirm, Space, Tag, Tooltip, Upload } from "antd";
import axios from "axios";
import React, { Component } from "react";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico, dineroDisabledMask, HeaderActions, NotificacionMovimientosInventario } from "../../../Components/Items";
import { CloseCircleOutlined, CopyOutlined, SendOutlined, DollarOutlined, ShoppingOutlined, FileTextOutlined, CheckOutlined, ThunderboltOutlined, SortAscendingOutlined, SortDescendingOutlined, FieldNumberOutlined, ArrowUpOutlined, ArrowDownOutlined, CaretDownOutlined, EyeOutlined, SearchOutlined, DownloadOutlined, ImportOutlined } from "@ant-design/icons";
import ModalDescargarDocumentos from "../../../Components/ModalDescargarDocumentos";
import descargarDocumentosMasivo, { MODULOS } from "../../../Components/DescargarDocumentosMasivo";
import CancelarVenta from "./CancelarVenta/CancelarVenta";
import EnviosVenta from "./EnviosVenta/EnviosVenta";
import ModalPrevisualizarVenta from "./ModalPrevisualizarVenta/ModalPrevisualizarVenta";
import ModalVentasPorEntregar from "./ModalVentasPorEntregar/ModalVentasPorEntregar";
import ModalElegirImpresora from "../../PuntoDeVenta/ModalElegirImpresora/ModalElegirImpresora";
import { cambiarImpresora } from "../../../store/actions/empresa";
import { descriptorEstatusSat } from "../../../Utils/estatusSat.utils";
import VerificarEstatusFiscalMasivo from "./VerificarEstatusFiscalMasivo/VerificarEstatusFiscalMasivo";
import qz from "qz-tray";

moment.locale("es");

class Ventas extends Component {
  tableRef = null;
  state = {
    todasVentas: [],
    loading: false,
    modalCancelacion: false,
    modalCancelacionId: null,
    modalEnvios: false,
    modalEnviosId: null,
    modalPreview: false,
    modalPreviewId: null,
    valor: 5,
    totalRecords: 0,
    facturaVariasRemisiones: false,
    facturarConDevoluciones: false,
    regularizarInventarioVentas: false,
    anticipos: false,
    modalCancelacionTimbre: false,
    modalCancelacionCargaHistorica: false,
    modalVerificacionMasiva: false,
    textoFiltro: '',
    avisoFacturaGlobal: null,
    ventasSeleccionadas: [],
    modalDescarga: { visible: false, loading: false, progreso: { hechos: 0, total: 0 } },
    modalPorEntregar: false,
    ventasPorEntregar: [],
    totalPorEntregar: 0,
  };

  componentDidMount() {
    this.revisarVentasPorEntregar();
  }

  // Complemento `avisoVentasPorEntregarVendedor`: una vez al dia (por empresa y
  // usuario) se le muestran al vendedor sus ventas pendientes de entregar. En
  // localStorage se guarda la fecha del ultimo aviso. El backend decide si el
  // complemento esta activo, asi que aqui no se lee ninguna bandera.
  revisarVentasPorEntregar() {
    const clave = `ventasPorEntregar_${this.props.empresaId}_${this.props.usuarioId}`;
    const hoy = moment().format("YYYY-MM-DD");
    try {
      if (localStorage.getItem(clave) === hoy) return;
    } catch (e) { }

    axios
      .post(
        "ventas/ventasPorEntregarVendedor",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 1 || !res.data.activo) return;
        try {
          localStorage.setItem(clave, hoy);
        } catch (e) { }
        if (res.data.ventas?.length > 0) {
          this.setState({
            modalPorEntregar: true,
            ventasPorEntregar: res.data.ventas,
            totalPorEntregar: res.data.total || res.data.ventas.length,
          });
        }
      })
      .catch((error) => {
        console.error("Error al consultar ventas por entregar:", error);
      });
  }

  abrirDescarga() {
    this.setState({ modalDescarga: { visible: true, loading: false, progreso: { hechos: 0, total: 0 } } });
  }

  cerrarDescarga() {
    this.setState({ modalDescarga: { visible: false, loading: false, progreso: { hechos: 0, total: 0 } } });
  }

  async confirmarDescarga(formatos) {
    this.setState((prev) => ({ modalDescarga: { ...prev.modalDescarga, loading: true } }));
    await descargarDocumentosMasivo({
      modulo: "venta",
      ids: this.state.ventasSeleccionadas,
      empresaId: this.props.empresaId,
      headersToken: this.props.headersToken,
      ...formatos,
      onProgreso: (hechos, total) => this.setState((prev) => ({
        modalDescarga: { ...prev.modalDescarga, progreso: { hechos, total } },
      })),
    });
    this.cerrarDescarga();
  }

  consultarVentas(params) {
    this.setState({ loading: true });
    axios
      .post(
        "ventas/selectVentas",
        { empresaId: this.props.empresaId, ...params },
        {
          headers: this.props.headersToken,
        }
      )
      .then(async (res) => {
        if (res.data.success === 2) {
          this.setState({
            todasVentas: res.data.data.map((value) => {
              let numero = ''
              if (value.factura) {
                if (numero !== '') {
                  numero += ' '
                }
                numero += (value.facturaSerie ? value.facturaSerie : 'F') + ' ' + value.facturaNumero
              }
              if (value.facturaGlobal) {
                if (numero !== '') {
                  numero += ' '
                }
                numero += (value.facturaGlobalSerie ? value.facturaGlobalSerie : 'FG') + ' ' + (value.facturaGlobalNumero ? value.facturaGlobalNumero : '')
              }
              if (value.remision) {
                if (numero !== '') {
                  numero += ' '
                }
                numero += (value.remisionSerie ? value.remisionSerie : 'R') + ' ' + value.remisionNumero + (value.sufijoPartida ? (' ' + value.sufijoPartida) : '')
              }
              return {
                ...value,
                fechaVenta: value.fechaVenta || value.fechaFactura || value.fechaRemision,
                numero: numero,
                clienteNombre: value.cliente.persona ? value.cliente.razonSocial : (value.cliente.nombre + ' ' + value.cliente.apellidoPaterno + ' ' + value.cliente.apellidoMaterno),
                clienteClave: value.cliente.clave || '',
                clienteNombreComercial: value.cliente.nombreComercial || '',
                clienteRfc: value.cliente.rfc,
                cliente: (value.cliente.persona ? value.cliente.razonSocial : (value.cliente.nombre + ' ' + value.cliente.apellidoPaterno + ' ' + value.cliente.apellidoMaterno)) + " - " + value.cliente.rfc,
                claveCliente: (value.cliente.nombreComercial || '') + (value.cliente.clave ? ` (${value.cliente.clave})` : ''),
                doctor: (this.props.equipoMedico && value.doctor) ? (value.doctor.nombre) : '',
                paciente: (this.props.equipoMedico && value.paciente) ? (value.paciente.nombre) : '',
                cirugia: (this.props.equipoMedico && value.cirugia) ? value.cirugia.nombre : '',
                vendedor: value.vendedor ? (value.vendedor.nombre + " " + (value.vendedor.apellidoPaterno || "") + ' ' + (value.vendedor.apellidoMaterno || "")) : '',
                // Campos para la columna Estado
                facturaGlobal: value.facturaGlobal,
                ventaProgramada: value.ventaProgramada,
                sesionId: value.sesionId,
                ventaOnline: value.ventaOnline,
                accion: {
                  _id: value._id,
                  cancelacion: value.cancelacion,
                  // La columna Accion recibe `record.accion`, no el registro: agregar el campo
                  // al $project del backend y al spread de arriba NO basta, si no esta listado
                  // aqui llega undefined y el tag falla en silencio.
                  verificacionSat: value.verificacionSat,
                  dataFactura: !!value.dataFactura,
                  estado: value.estado,
                  estadoCosteo: value.estadoCosteo,
                  servicios: value.servicios,
                  estadoPago: value.estadoPago,
                  facturaGlobal: value.facturaGlobal,
                  sesionId: value.sesionId,
                  cajaId: value.cajaId,
                  factura: value.factura,
                  contado: value.contado,
                  remision: value.remision,
                  cuentasXC: value.cuentasXC,
                  envios: value.envios,
                  flete: value.flete,
                  ventaProgramada: value.ventaProgramada,
                  ventaOnline: value.ventaOnline,
                  sinContabilidad: value.sinContabilidad || false,
                  quitarImpuestos: value.quitarImpuestos || false,
                  // Necesario para puedeCancelar: una historica PPD llega con estadoPago 3 y
                  // contado 2, asi que sin esta bandera el boton de cancelar queda deshabilitado.
                  cargaHistorica: value.cargaHistorica || false,
                },
              };
            }),
            tickets: res.data.tickets || false,
            facturaVariasRemisiones: res.data.facturaVariasRemisiones || false,
            facturarConDevoluciones: res.data.facturarConDevoluciones || false,
            regularizarInventarioVentas: res.data.regularizarInventarioVentas || false,
            anticipos: res.data.anticipos || false,
            avisoFacturaGlobal: res.data.avisoFacturaGlobal || null,
            totalRecords: res.data.totalRecords || 0,
            loading: false
          });
          if (!this.props.impresoraSeleccionada && res.data.tickets) {
            await this.activarQzTray();
            this.setState({ modalElegirImpresora: true, loading: false })
          }
        } else {
          this.setState({ todasVentas: [], loading: false });
        }
      })
      .catch((error) => {
        console.error('Error al consultar ventas:', error);
        this.setState({ loading: false });
      });
  }

  activarQzTray = () => {
    qz.security.setCertificatePromise(function (resolve, reject) {
      //Preferred method - from server
      fetch("../cert_qz_tray.txt", { cache: 'no-store', headers: { 'Content-Type': 'text/plain' } })
        .then(function (data) { data.ok ? resolve(data.text()) : reject(data.text()); });
    })

    qz.security.setSignatureAlgorithm("SHA512"); // Since 2.1
    qz.security.setSignaturePromise(function (toSign) {
      return function (resolve, reject) {
        // Preferred method - from server

        // axios.post('/puntoVenta/signQzTray', toSign, {
        //   headers: {
        //     ...this.props.headersToken,
        //     'Content-Type': 'text/plain',
        //   }
        // })
        //   .then(response => {
        //     console.log("Firma recibida:", response.data);
        //     resolve(response.data); // ✔️ Texto plano (la firma base64)
        //   })
        //   .catch(error => {
        //     console.error('Error firmando para QZ Tray:', error);
        //     reject("No se pudo firmar el contenido");
        //   });

        fetch("../erp/api/puntoVenta/signQzTray?request=" + toSign, { cache: 'no-store', headers: { 'Content-Type': 'text/plain' } })
          .then(function (data) { data.ok ? resolve(data.text()) : reject(data.text()); });

        //Alternate method - unsigned
        // resolve(); // remove this line in live environment
      };
    });
  }

  agregarVenta() {
    this.props.history.push("/panel/agregarVenta");
  }
  agregarAnticipo() {
    this.props.history.push("/panel/agregarVenta", { anticipo: true });
  }
  puntoDeVenta() {
    this.props.history.push("/panel/puntoDeVenta");
  }
  facturaGlobal() {
    this.props.history.push("/panel/facturaGlobal");
  }
  entregarInsumosVenta(id) {
    this.props.history.push("/panel/entregarInsumosVenta", { id });
  }
  generarEnvioVenta(id) {
    this.props.history.push("/panel/generarEnvioVenta", { id, certificada: this.props.certificada });
  }
  costearVenta(id) {
    this.props.history.push("/panel/costearVenta", { id });
  }
  generarFacturaVenta(id) {
    this.props.history.push("/panel/generarFacturaVenta", { id });
  }
  cancelarVenta(value, cargaHistorica = false) {
    this.setState({ modalCancelacion: true, modalCancelacionId: value, modalCancelacionCargaHistorica: cargaHistorica });
  }
  cerrarCancelarVenta() {
    this.setState({
      modalCancelacion: false,
      modalCancelacionId: null,
      modalCancelacionCargaHistorica: false,
      // Sin este reset, despues de usar una vez "Cancelar nuevamente el timbre fiscal" toda
      // cancelacion posterior se manda con modalCancelacionTimbre y el backend se salta la
      // reversion local completa.
      modalCancelacionTimbre: false,
    });
    if (this.tableRef) {
      this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
  }
  enviosVenta(value) {
    this.setState({ modalEnvios: true, modalEnviosId: value });
  }
  cerrarEnviosVenta() {
    this.setState({
      modalEnvios: false,
      modalEnviosId: null,
    });
    if (this.tableRef) {
      this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
  }
  previsualizarVenta(value) {
    this.setState({ modalPreview: true, modalPreviewId: value });
  }
  cerrarPrevisualizarVenta() {
    this.setState({
      modalPreview: false,
      modalPreviewId: null,
    });
  }

  cargarXmlPrevio(e, id) {
    this.setState({ loading: true });
    let fd = new FormData();
    fd.append("empresaId", this.props.empresaId);
    fd.append("ventaId", id);
    fd.append("xml", e.file);
    axios
      .post("ventas/ligarXml", fd, {
        headers: {
          ...this.props.headersToken,
        },
      })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha ligado correctamente el xml");
          if (this.tableRef) {
            this.tableRef.updateExternalFilters({ valor: this.state.valor });
          }
        } else if (res.data.success === 1) {
          message.error(res.data.message ? res.data.message : "Hubo un error y el xml no se ligo");
        } else {
          message.error("Hubo un error y el xml no se ligo");
        }
      });
  }

  duplicarVenta(id) {
    this.props.history.push("/panel/agregarVenta", { duplicar: id });
  }

  seleccionarImpresoraTickets() {
    this.setState({ modalElegirImpresora: true });
  }

  onConfirmarImpresora = (impresora) => {
    this.props.cambiarImpresora({ impresora });
    this.setState({ modalElegirImpresora: false, loading: false });
    message.success(`Impresora seleccionada: ${impresora}`);
  };

  facturarVariasRemisiones() {
    this.props.history.push("/panel/facturarVariasRemisiones");
  }

  regularizarInventarioVentas() {
    this.props.history.push("/panel/regularizarInventarioVentas");
  }

  cancelarTimbreFiscal(value) {
    this.setState({ modalCancelacion: true, modalCancelacionId: value, modalCancelacionTimbre: true, modalCancelacionCargaHistorica: false });
  }

  checarEstatusFiscal(ventaId) {
    this.setState({ loading: true });
    axios
      .post("ventas/checarEstatusFiscalVenta", { ventaId, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2 && res.data.cancelada) {
          message.success(res.data.message);
          NotificacionMovimientosInventario(res.data.movimientosIds);
        } else if (res.data.success === 2) {
          message.info(res.data.message);
        } else if (res.data.success === 3) {
          notification.info({ message: "Ya estaba cancelada", description: res.data.message });
        } else {
          notification.error({ message: "Error", description: res.data.message || "No se pudo consultar el estatus fiscal" });
        }
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
      })
      // Sin este catch, un timeout o un 500 dejaba `loading: true` colgado y la tabla en
      // spinner para siempre. Y el SAT es justo un servicio que se cae seguido.
      .catch(() => {
        this.setState({ loading: false });
        notification.error({
          message: "Error",
          description: "No se pudo consultar el estatus fiscal en el SAT. Intenta de nuevo en unos minutos.",
        });
      });
  }

  abrirVerificacionMasiva() {
    this.setState({ modalVerificacionMasiva: true });
  }

  cerrarVerificacionMasiva(recargar) {
    this.setState({ modalVerificacionMasiva: false });
    if (recargar && this.tableRef) {
      this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
  }

  render() {
    const ventaStatusTags = {
      facturaGlobal: {
        tag: <Tag color="orange">FG</Tag>,
        tooltip: "Factura Global"
      },
      ventaProgramada: {
        tag: <Tag color="blue">VP</Tag>,
        tooltip: "Venta Programada"
      },
      sesionPuntoVenta: {
        tag: <Tag color="green">PV</Tag>,
        tooltip: "Punto de Venta"
      },
      ventaOnlineNoPagada: {
        tag: <Tag color="red" className="square-tag">VO: Sin pagar</Tag>,
        tooltip: "Esta venta online aún no se confirma el pago"
      },
      sinImpuestos: {
        tag: <Tag color="gold" className="square-tag">SI</Tag>,
        tooltip: "Venta no contable con impuestos quitados"
      },
      cargaHistorica: {
        tag: <Tag color="default" className="square-tag">Histórico</Tag>,
        tooltip: "Venta cargada como histórico en la implementación (sin contabilidad)"
      }
    };

    const agregarEquipoMedico = this.props.equipoMedico ? [
      {
        title: "Doctor / Paciente",
        dataIndex: "doctor",
        key: "doctor",
        buscar: "doctor",
        render: (_, record) => (
          <div>
            <div style={{
              fontSize: "12px",
              fontWeight: 500,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }}>
              {record.doctor}
            </div>
            <div style={{
              fontSize: "12px",
              color: "#666",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }}>
              {record.paciente + (record.cirugia ? ` - ${record.cirugia}` : '')}
            </div>
          </div>
        ),
        width: "15%",
        ellipsis: true,
      },
    ] : [
      {
        title: "Proyecto",
        dataIndex: "proyecto",
        key: "proyecto",
        responsive: ["md"],
        buscar: 'proyecto',
        render: (value) => <span style={{ fontSize: "11px" }}>{value.nombre}</span>,
        width: "9%",
        ellipsis: true,
      },
    ]

    // Orden actual de la columna F/R 
    const sorterFR = (this.tableRef && this.tableRef.state.sorter) || {};
    const ordenFR = (sorterFR.field === "serie" || sorterFR.field === "numero") ? sorterFR : null;

    const menuOrdenFR = (
      <Menu
        className="menu-orden-fr-menu"
        selectedKeys={ordenFR ? [`${ordenFR.field}-${ordenFR.order}`] : []}
        onClick={({ key, domEvent }) => {
          domEvent.stopPropagation();
          if (!this.tableRef) return;
          if (key === "quitar") {
            this.tableRef.setSorter();
          } else {
            const [field, order] = key.split("-");
            this.tableRef.setSorter(field, order);
          }
        }}
      >
        <Menu.ItemGroup title="Por letra (serie)">
          <Menu.Item key="serie-ascend" icon={<SortAscendingOutlined />}>A → Z</Menu.Item>
          <Menu.Item key="serie-descend" icon={<SortDescendingOutlined />}>Z → A</Menu.Item>
        </Menu.ItemGroup>
        <Menu.ItemGroup title="Por número (folio)">
          <Menu.Item key="numero-ascend" icon={<FieldNumberOutlined />}>1 → 9 (ascendente)</Menu.Item>
          <Menu.Item key="numero-descend" icon={<FieldNumberOutlined />}>9 → 1 (descendente)</Menu.Item>
        </Menu.ItemGroup>
        <Menu.Divider />
        <Menu.Item key="quitar" disabled={!ordenFR}>Quitar orden</Menu.Item>
      </Menu>
    );

    const columns = [
      {
        title: (
          <Dropdown overlay={menuOrdenFR} overlayClassName="menu-orden-fr" trigger={["click"]}>
            <span className={"fr-orden-trigger" + (ordenFR ? " fr-orden-activo" : "")}>
              F/R{" "}
              {ordenFR?.field === "serie" ? (
                ordenFR.order === "ascend"
                  ? <SortAscendingOutlined style={{ color: "#00BFD6", fontSize: 12 }} />
                  : <SortDescendingOutlined style={{ color: "#00BFD6", fontSize: 12 }} />
              ) : (
                <FieldNumberOutlined style={{ color: ordenFR ? "#00BFD6" : "#999", fontSize: 12 }} />
              )}
              {ordenFR?.field === "numero" && (
                ordenFR.order === "ascend"
                  ? <ArrowUpOutlined style={{ color: "#00BFD6", fontSize: 10 }} />
                  : <ArrowDownOutlined style={{ color: "#00BFD6", fontSize: 10 }} />
              )}
              {" "}<CaretDownOutlined className="fr-orden-caret" />
            </span>
          </Dropdown>
        ),
        dataIndex: "numero",
        key: "numero",
        buscar: "numero",
        render: (_, record) => {
          const sat = descriptorEstatusSat(record);

          return (
            <div>
              <div style={{ fontSize: "12px", display: "flex", alignItems: "center", gap: "4px" }}>
                <span>{record.numero}</span>
                {sat && this.props.permisoCancelarVenta && (
                  sat.verificable ? (
                    <Popconfirm
                      title="Se consultará el estatus real de esta factura en el SAT. Si aparece cancelada, se aplicará la cancelación en el sistema. ¿Continuar?"
                      onConfirm={() => this.checarEstatusFiscal(record._id)}
                      okText="Sí"
                      cancelText="No"
                    >
                      <Tooltip title={sat.tooltip}>
                        <SearchOutlined style={{ color: sat.color, cursor: "pointer" }} />
                      </Tooltip>
                    </Popconfirm>
                  ) : (
                    // Carga histórica cancelada sólo en el sistema: su CFDI debe seguir
                    // vigente en el SAT, así que la lupa no se puede picar.
                    <Tooltip title={sat.tooltip}>
                      <SearchOutlined style={{ color: sat.color, cursor: "not-allowed" }} />
                    </Tooltip>
                  )
                )}
              </div>
              {record.ordenDeCompra && (
                <div style={{ fontSize: "12px", color: "#666" }}>
                  OC: {record.ordenDeCompra}
                </div>
              )}
            </div>
          );
        },
        width: "12%",
        ellipsis: true,
      },
      {
        title: "OC",
        dataIndex: "ordenDeCompra",
        key: "ordenDeCompra",
        buscar: "ordenDeCompra",
        responsive: [],
        width: 0,
      },
      ...agregarEquipoMedico,
      {
        title: "Fecha",
        dataIndex: "fechaVenta",
        key: "fechaVenta",
        defaultSortOrder: 'descend',
        sorter: true,
        render: (value) => moment(value).locale("es").format("DD/MM/YY HH:mm"),
        width: "10%",
        ellipsis: true,
        align: "center",
      },
      {
        title: (
          <span>
            Cliente / Vendedor{" "}
            <Tooltip title="Se ordena alfabéticamente">
              <SortAscendingOutlined style={{ color: "#999", fontSize: 12 }} />
            </Tooltip>
          </span>
        ),
        dataIndex: "clienteNombre",
        key: "clienteNombre",
        buscar: "cliente",
        sorter: true,
        showSorterTooltip: false,
        render: (_, record) => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ fontSize: "12px", fontWeight: "bold" }}>
              {record.clienteClave ? `${record.clienteClave} - ${record.clienteNombre}` : record.clienteNombre}
            </span>
            {/* {record.clienteNombreComercial && (
              <span style={{ fontSize: "10px", color: "#999", fontStyle: "italic" }}>↳ {record.clienteNombreComercial}</span>
            )} */}
            <span style={{ fontSize: "12px", color: "#666" }}>{record.vendedor || "-"}</span>
          </div>
        ),
        width: window.innerWidth >= 1800 ? "21%" : "23%",
        ellipsis: true,
      },
      {
        title: "RFC",
        dataIndex: "clienteRfc",
        key: "clienteRfc",
        render: (value, record) => (
          <div>
            <div style={{ fontSize: "12px", fontWeight: "bold" }}>
              {value}
            </div>
            <div style={{ fontSize: "12px", color: "#666" }}>
              {record.contado === 1 ? ("PUE" + (record.cuentasXC ? " - CXC" : "")) : "PPD"}
            </div>
          </div>
        ),
        width: "8%",
        ellipsis: true,

      },
      {
        title: "Subtotal / Total",
        dataIndex: "subtotal",
        key: "subtotal",
        sorter: true,
        render: (_, record) => (
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: "12px", color: "#666", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
              <span>{dineroDisabledMask(record.subtotal)}</span>
              {record.moneda && <span style={{ fontSize: "12px", color: "#999" }}>{record.moneda}</span>}
            </div>
            <div style={{ fontSize: "12px", fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
              <span>{dineroDisabledMask(record.totalPagar)}</span>
              {record.moneda && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda}</span>}
            </div>
          </div>
        ),
        buscar: "subtotal",
        width: "12%",
        ellipsis: true,
        align: "right",
      },
      {
        title: "Total",
        dataIndex: "total",
        key: "total",
        sorter: true,
        buscar: "total",
        responsive: [],
        width: 0,
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        responsive: ["md"],

        render: (value, record) => {
          let estadoPrincipal = [];
          let estadosSecundarios = [];

          // Tag principal de estado
          if (value === 0) {
            if (record.facturaId) {
              estadoPrincipal.push(<Tag color="purple" className="square-tag">Facturada</Tag>);
            } else if (record.refacturadoId) {
              estadoPrincipal.push(<Tag color="magenta" className="square-tag">Refacturada</Tag>);
            } else {
              estadoPrincipal.push(<Tag color="red" className="square-tag">Cancelada</Tag>);
            }
          }
          if (value === 1) {
            estadoPrincipal.push(<Tag color="blue" className="square-tag">Sin entregar</Tag>);
          }
          if (value === 2) {
            estadoPrincipal.push(<Tag color="orange" className="square-tag">Entregado par.</Tag>);
          }
          if (value === 3) {
            if (record.anticipo) {
              estadoPrincipal.push(<Tag color="cyan" className="square-tag">Anticipo</Tag>);
            } else {
              estadoPrincipal.push(<Tag color="green" className="square-tag">Entregado</Tag>);
            }
          }

          // Tags adicionales de tipo de venta (segunda fila)
          if (record.facturaGlobal) {
            estadosSecundarios.push(
              <Tooltip title={ventaStatusTags.facturaGlobal.tooltip}>
                {ventaStatusTags.facturaGlobal.tag}
              </Tooltip>
            );
          }

          if (record.ventaProgramada) {
            estadosSecundarios.push(
              <Tooltip title={ventaStatusTags.ventaProgramada.tooltip}>
                {ventaStatusTags.ventaProgramada.tag}
              </Tooltip>
            );
          }

          if (record.sesionId) {
            estadosSecundarios.push(
              <Tooltip title={ventaStatusTags.sesionPuntoVenta.tooltip}>
                {ventaStatusTags.sesionPuntoVenta.tag}
              </Tooltip>
            );
          }

          if (record.sinContabilidad && record.quitarImpuestos) {
            estadosSecundarios.push(
              <Tooltip title={ventaStatusTags.sinImpuestos.tooltip}>
                {ventaStatusTags.sinImpuestos.tag}
              </Tooltip>
            );
          }

          if (record.cargaHistorica) {
            estadosSecundarios.push(
              <Tooltip title={ventaStatusTags.cargaHistorica.tooltip}>
                {ventaStatusTags.cargaHistorica.tag}
              </Tooltip>
            );
          }

          const ventaOnlineNoPagada = record.ventaOnline && record.estadoPago !== 3;

          return (
            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              <Space direction="horizontal" size="small">{estadoPrincipal}</Space>
              {ventaOnlineNoPagada && (
                <Tooltip title={ventaStatusTags.ventaOnlineNoPagada.tooltip}>
                  {ventaStatusTags.ventaOnlineNoPagada.tag}
                </Tooltip>
              )}
              {estadosSecundarios.length > 0 && (
                <Space direction="horizontal" size="small">{estadosSecundarios}</Space>
              )}
            </div>
          );
        },
        width: window.innerWidth >= 1800 ? "10%" : "13%",
        ellipsis: true,
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: window.innerWidth >= 1800 ? "18%" : "25%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value, index) => {
          if (value.estado === 0) {

            let buttons = [];

            buttons.push(
              <Tooltip title="Previsualizar Venta" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`preview-${index}`}
                  type="default"
                  size="small"
                  icon={<EyeOutlined />}
                  onClick={() => this.previsualizarVenta(value._id)}
                >
                </ButtonItem>
              </Tooltip>
            );

            const puedeDuplicarCancelada = this.props.duplicarVentas;
            buttons.push(
              <Tooltip title={puedeDuplicarCancelada ? "Duplicar Venta" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`duplicar-${index}`}
                  type="default"
                  size="small"
                  lila
                  icon={<CopyOutlined />}
                  onClick={() => puedeDuplicarCancelada && this.duplicarVenta(value._id)}
                  disabled={!puedeDuplicarCancelada}
                >
                </ButtonItem>
              </Tooltip>
            );

            if (!value.factura) return <Space direction="horizontal">{buttons}</Space>;

            // El color, el texto y la explicacion salen del helper compartido
            // (src/Utils/estatusSat.utils.js). Antes el switch de estadoCancelacion y el
            // mapa de colores estaban duplicados aqui, en la columna del folio y en las
            // otras tres pantallas, y los textos ya habian divergido entre si.
            const sat = descriptorEstatusSat(value);

            if (sat) {
              buttons.push(
                <Tooltip title={sat.tooltip}>
                  <Tag color={sat.tagColor} className="square-tag2">{sat.texto}</Tag>
                </Tooltip>
              );
            }

            // Rechazada por el SAT: se le puede volver a pedir la cancelacion al PAC. No
            // aplica a las canceladas solo en el sistema, que no tienen timbre que reintentar.
            if (value?.cancelacion?.statusCancelacion === 3 && !value?.cancelacion?.sinSat) {
              buttons.push(
                <Popconfirm
                  title="¿Cancelar nuevamente el timbre fiscal?"
                  onConfirm={() => this.cancelarTimbreFiscal(value._id)}
                  okText="Sí"
                  cancelText="No"
                >
                  <CloseCircleOutlined style={{ color: "red" }} />
                </Popconfirm>
              );
            }

            return <Space direction="horizontal">{buttons}</Space>;
          };

          let buttons = [];

          // Venta VIVA que el SAT ya reporta cancelada: se canceló fuera del ERP (portal del
          // SAT, el contador). Lo detecta el barrido nocturno, que a propósito no aplica la
          // reversa. El tag va primero porque es lo más urgente de la fila: mientras siga así,
          // la contabilidad y el inventario están sostenidos por un CFDI que ya no existe.
          if (value?.verificacionSat?.discrepancia) {
            buttons.push(
              <Tooltip title="El SAT reporta esta factura como CANCELADA, pero en el sistema sigue vigente. Verifica el estatus fiscal desde la lupa del folio para aplicar la cancelación.">
                <Tag color="red" className="square-tag2">SAT: Cancelada por fuera</Tag>
              </Tooltip>
            );
          }

          buttons.push(
            <Tooltip title="Previsualizar Venta" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`preview-${index}`}
                type="default"
                size="small"
                icon={<EyeOutlined />}
                onClick={() => this.previsualizarVenta(value._id)}
              >
              </ButtonItem>
            </Tooltip>
          );

          const puedeEntregar = (value.estado === 1 || value.estado === 2) && this.props.permisoEntregarInsumosVenta;
          buttons.push(
            <Tooltip title={puedeEntregar ? "Entregar Insumos" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`entregar-${index}`}
                type="default"
                size="small"
                naranja
                icon={<ShoppingOutlined />}
                onClick={() => puedeEntregar && this.entregarInsumosVenta(value._id)}
                disabled={!puedeEntregar}
              >
              </ButtonItem>
            </Tooltip>
          );
          const puedeEnviar = (value.estado === 1 || value.estado === 2) && this.props.envios && !value.flete;
          buttons.push(
            <Tooltip title={puedeEnviar ? "Generar Envío" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`enviar-${index}`}
                type="default"
                size="small"
                cyan
                icon={<CheckOutlined />}
                onClick={() => puedeEnviar && this.generarEnvioVenta(value._id)}
                disabled={!puedeEnviar}
              >
              </ButtonItem>
            </Tooltip>
          );

          const puedeVerEnvios = value.envios?.length > 0;
          buttons.push(
            <Tooltip title={puedeVerEnvios ? "Envíos" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`envios-${index}`}
                type="default"
                size="small"
                azulMarino
                icon={<SendOutlined />}
                onClick={() => puedeVerEnvios && this.enviosVenta(value._id)}
                disabled={!puedeVerEnvios}
              >
              </ButtonItem>
            </Tooltip>
          );

          const puedeDuplicar = this.props.duplicarVentas;
          buttons.push(
            <Tooltip title={puedeDuplicar ? "Duplicar Venta" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`duplicar-${index}`}
                type="default"
                size="small"
                lila
                icon={<CopyOutlined />}
                onClick={() => puedeDuplicar && this.duplicarVenta(value._id)}
                disabled={!puedeDuplicar}
              >
              </ButtonItem>
            </Tooltip>
          );
          const puedeCostear = value.servicios && value.estadoCosteo === 0;
          buttons.push(
            <Tooltip title={puedeCostear ? "Costear Venta" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`costear-${index}`}
                type="default"
                size="small"
                amarillo
                icon={<DollarOutlined />}
                onClick={() => puedeCostear && this.costearVenta(value._id)}
                disabled={!puedeCostear}
              >
              </ButtonItem>
            </Tooltip>
          );

          const ventaOnlineNoPagada = value.ventaOnline && value.estadoPago !== 3;
          const puedeFacturar = !ventaOnlineNoPagada && !value.sinContabilidad && value.remision && !value.facturaGlobal && !value.factura && this.props.certificada && this.props.permisoFacturarVentas && (value.estadoPago === 0 || value.contado === 1 || this.state.facturarConDevoluciones);
          buttons.push(
            <Tooltip title={ventaOnlineNoPagada ? "Esta venta online aún no se confirma el pago" : (puedeFacturar ? "Facturar" : "No disponible")} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`facturar-${index}`}
                type="default"
                size="small"
                lima
                onClick={() => puedeFacturar && this.generarFacturaVenta(value._id)}
                disabled={!puedeFacturar}
                style={{ width: 24, height: 24, padding: 0 }}
              >
                F
              </ButtonItem>
            </Tooltip>
          );

          // Las cargas historicas (CXC Implementacion en modo solo historico) nacen con
          // estadoPago 3 sin poliza ni pagos detras, asi que se pueden cancelar para
          // poder deshacer una importacion equivocada.
          const puedeCancelar = value.estado !== 0 && !value.facturaGlobal && (value.estadoPago === 0 || value.contado === 1 || value.cargaHistorica) && (!value.cuentasXC || value.estadoPago === 0 || value.cargaHistorica) && this.props.permisoCancelarVenta && (value.envios?.length <= 0 || !value.envios || value.estado === 1);
          buttons.push(
            <Popconfirm
              key={`cancelar-${index}`}
              title={
                value.cargaHistorica
                  ? "Esta venta es una carga historica: se cancelara solo en el sistema, el CFDI NO se cancelara en el SAT"
                  : this.props.certificada && value.factura
                    ? "Seguro que quieres cancelar esta venta, tambien se cancelara la factura"
                    : "Seguro que quieres cancelar esta venta"
              }
              onConfirm={() => this.cancelarVenta(value._id, !!value.cargaHistorica)}
              okText="Si"
              cancelText="No"
              disabled={!puedeCancelar}
            >
              <Tooltip title={puedeCancelar ? "Cancelar" : "No se puede cancelar"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  type="default"
                  size="small"
                  rojo
                  icon={<CloseCircleOutlined />}
                  disabled={!puedeCancelar}
                >
                </ButtonItem>
              </Tooltip>
            </Popconfirm>
          );

          const puedeCargarXml = value.remision && !value.facturaGlobal && !value.factura && (value.estadoPago === 0 || value.contado === 1) && this.props.cargarXmlPrevio && this.props.permisoXmlPrevio;
          buttons.push(
            <Tooltip title={puedeCargarXml ? "Cargar XML Previo" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <Upload
                showUploadList={{
                  showRemoveIcon: false,
                  showPreviewIcon: false,
                }}
                fileList={[]}
                customRequest={(e) => puedeCargarXml && this.cargarXmlPrevio(e, value._id)}
                accept=".xml"
                disabled={!puedeCargarXml}
                style={{ display: 'inline-block', verticalAlign: 'middle' }}
              >
                <ButtonItem
                  type="default"
                  size="small"
                  blanco
                  icon={<FileTextOutlined />}
                  disabled={!puedeCargarXml}
                >
                </ButtonItem>
              </Upload>
            </Tooltip>
          );
          return <div className="acciones-container">{buttons}</div>;
        },
      }
    ];
    return (
      <>
        <PageHeader
          title="Ventas"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              {window.innerWidth > 1000 &&
                <>
                  <SegmentedItem
                    options={[{ label: 'Entregado', value: 1 }, { label: 'Entregado Parcialmente', value: 2 }, { label: 'Sin Entregar', value: 3 }, { label: 'Todos', value: 5 }, { label: 'Cancelado', value: 4 }]}
                    onChange={(value) => {
                      if (this.tableRef) {
                        this.tableRef.updateExternalFilters({ valor: value });
                      }
                      this.setState({ valor: value });
                    }}

                    value={this.state.valor}
                  />
                  <div className="header-divider"></div>
                </>
              }
              {this.state.ventasSeleccionadas.length > 0 &&
                <ButtonItem
                  blanco
                  icon={<DownloadOutlined />}
                  key="descargarVentas"
                  onClick={this.abrirDescarga.bind(this)}
                >
                  Descargar ({this.state.ventasSeleccionadas.length})
                </ButtonItem>}
              <HeaderActions badgeDot={!!this.state.avisoFacturaGlobal}>
                {this.props.permisoAgregarVenta && (
                  <>
                    {this.props.certificada && this.props.permisoFacturaGlobal && (
                      <ButtonItem
                        key="facturaGlobal"
                        type="primary"
                        cuero
                        onClick={() => {
                          if (this.state.avisoFacturaGlobal) {
                            this.props.history.push("/panel/facturaGlobal", {
                              remisionesIds: this.state.avisoFacturaGlobal.remisionesIds,
                              avisoId: this.state.avisoFacturaGlobal._id,
                              remisiones: this.state.avisoFacturaGlobal.remisiones,
                              periodicidad: this.state.avisoFacturaGlobal.periodicidad,
                              fechaAviso: this.state.avisoFacturaGlobal.fechaAviso,
                              filtros: this.state.avisoFacturaGlobal.filtros,
                            });
                          } else {
                            this.facturaGlobal();
                          }
                        }}
                      >
                        Factura Global
                        {this.state.avisoFacturaGlobal && (
                          <span style={{
                            display: 'inline-block',
                            width: 7,
                            height: 7,
                            backgroundColor: '#ff4d4f',
                            borderRadius: '50%',
                            marginLeft: 7,
                            verticalAlign: 'middle',
                            marginBottom: 1,
                          }} />
                        )}
                      </ButtonItem>
                    )}
                    {this.state.regularizarInventarioVentas && this.props.permisoRegularizarInventarioVentas && (
                      <ButtonItem
                        type="primary"
                        key="regularizarInventarioVentas"
                        verde
                        onClick={this.regularizarInventarioVentas.bind(this)}
                      >
                        Regularizar Inv.
                      </ButtonItem>
                    )}
                    {this.state.facturaVariasRemisiones && this.props.certificada && (
                      <ButtonItem
                        type="primary"
                        key="facturarVariasRemisiones"
                        lila
                        onClick={this.facturarVariasRemisiones.bind(this)}
                      >
                        F. Remisiones
                      </ButtonItem>
                    )}
                    {this.state.tickets && (
                      <ButtonItem
                        type="primary"
                        key="seleccionarImpresoraTickets"
                        blanco
                        onClick={this.seleccionarImpresoraTickets.bind(this)}
                      >
                        Impresora T.
                      </ButtonItem>
                    )}
                    {this.state.anticipos && this.props.certificada && (
                      <ButtonItem
                        type="primary"
                        key="agregarAnticipo"
                        cyan
                        onClick={this.agregarAnticipo.bind(this)}
                      >
                        Agregar Anticipo
                      </ButtonItem>
                    )}
                    {/* Mismo permiso que la lupa del folio: es la version en lote de lo
                        mismo, y ese permiso ya es el que gobierna cancelar una venta. */}
                    {this.props.permisoCancelarVenta && (
                      <ButtonItem
                        type="primary"
                        key="verificarEstatusFiscalMasivo"
                        blanco
                        onClick={this.abrirVerificacionMasiva.bind(this)}
                      >
                        Verificar SAT
                      </ButtonItem>
                    )}
                  </>
                )}
                {/* Fuera del bloque de permisoAgregarVenta: este boton tiene permiso propio.
                    Solo para escuelas: reasigna al alumno las ventas de libros digitales que
                    quedaron a nombre de Publico en General, a partir del numero de lote. */}
                {this.props.escuela && this.props.permisoImportarVentasLibrosDigitales && (
                  <Tooltip title="Importar Ventas de Libros Digitales">
                    <ButtonItem
                      type="primary"
                      key="importarVentasLibrosDigitales"
                      azul
                      icon={<ImportOutlined />}
                      onClick={() =>
                        this.props.history.push("/panel/importarLibrosDigitales")
                      }
                    >
                      Libros Digitales
                    </ButtonItem>
                  </Tooltip>
                )}
              </HeaderActions>

              {this.props.permisoAgregarVenta &&
                <ButtonItem
                  type="primary"
                  key="agregarVenta"
                  olivo
                  onClick={this.agregarVenta.bind(this)}
                  className="botonAgregar"
                >
                  Agregar Venta
                </ButtonItem>
              }
            </div>
          }
        />
        <ModalVentasPorEntregar
          visible={this.state.modalPorEntregar}
          ventas={this.state.ventasPorEntregar}
          total={this.state.totalPorEntregar}
          onCancel={() => this.setState({ modalPorEntregar: false })}
          onVerVenta={(id) => this.props.history.push("/panel/verVenta", { id })}
        />
        {this.state.avisoFacturaGlobal && this.props.permisoFacturaGlobal && this.props.certificada && (
          <div style={{
            backgroundColor: '#ffffff',
            border: '1px solid #b5e8f0',
            borderLeft: '4px solid #00BFD6',
            borderRadius: 6,
            padding: '8px 16px',
            marginBottom: 8,
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            fontSize: 13,
          }}>
            <ThunderboltOutlined style={{ color: '#00BFD6', fontSize: 16 }} />
            <span style={{ color: '#333' }}>
              <span style={{ color: '#00BFD6', fontWeight: 600 }}>Automatización Factura Global</span>
              {' — hay ventas pendientes de incluir en la factura global.'}
            </span>
          </div>
        )}
        <TableItemDinamico
          ref={(ref) => this.tableRef = ref}
          onRef={(ref) => this.tableRef = ref}
          totalRecords={this.state.totalRecords}
          onlyMineFilter
          estadosLeyenda={[
            { color: 'rgba(166, 255, 144, 0.6)', label: 'Apartado', key: 'apartado' },
            { color: 'rgba(255, 174, 82, 0.6)', label: 'Material recibido', key: 'material-recibido' },
          ]}
          onRow={(record, rowIndex) => {
            return {
              onDoubleClick: (event) => {
                this.props.history.push("/panel/verVenta", { id: record._id });
              },
            };
          }}
          anadirValorFiltro={this.state.valor}
          onFetchData={this.consultarVentas.bind(this)}
          loading={this.state.loading}
          size="small"
          dataSource={this.state.todasVentas}
          columns={columns}
          setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })}
          valorTextoDefault={""}
          filterStorageKey={"ventasFiltrosTabla" + this.props.empresaId}
          pagination={false}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={5}
          rowSelection={{
            selectedRowKeys: this.state.ventasSeleccionadas,
            onChange: (ventasSeleccionadas) => this.setState({ ventasSeleccionadas }),
            // La tabla pagina del lado del servidor: sin esto, antd tira las
            // llaves de las páginas anteriores al paginar.
            preserveSelectedRowKeys: true,
          }}
        />

        <ModalDescargarDocumentos
          visible={this.state.modalDescarga.visible}
          loading={this.state.modalDescarga.loading}
          progreso={this.state.modalDescarga.progreso}
          total={this.state.ventasSeleccionadas.length}
          tieneXml={MODULOS.venta.tieneXml}
          onClose={this.cerrarDescarga.bind(this)}
          onConfirm={this.confirmarDescarga.bind(this)}
        />
        <CancelarVenta
          visible={this.state.modalCancelacion}
          id={this.state.modalCancelacionId}
          cerrarCancelarVenta={this.cerrarCancelarVenta.bind(this)}
          modalCancelacionTimbre={this.state.modalCancelacionTimbre}
          cargaHistorica={this.state.modalCancelacionCargaHistorica}
        />
        {/* Se monta solo cuando esta abierto: su componentDidMount abre el seguidor del
            proceso masivo, y no tiene por que estar escuchando desde que carga la lista. */}
        {this.state.modalVerificacionMasiva && (
          <VerificarEstatusFiscalMasivo
            visible={this.state.modalVerificacionMasiva}
            cerrar={this.cerrarVerificacionMasiva.bind(this)}
          />
        )}
        <EnviosVenta
          history={this.props.history}
          visible={this.state.modalEnvios}
          id={this.state.modalEnviosId}
          cerrarEnviosVenta={this.cerrarEnviosVenta.bind(this)}
        />
        <ModalPrevisualizarVenta
          history={this.props.history}
          visible={this.state.modalPreview}
          ventaId={this.state.modalPreviewId}
          onCancel={this.cerrarPrevisualizarVenta.bind(this)}
        />
        <ModalElegirImpresora
          visible={this.state.modalElegirImpresora}
          onCancel={() => {
            this.props.cambiarImpresora({ impresora: this.props.impresoraSeleccionada || 'default' })
            if (this.tableRef) {
              this.tableRef.updateExternalFilters();
            }
            this.setState({ modalElegirImpresora: false, loading: false })
          }}
          onConfirmarImpresora={this.onConfirmarImpresora}
          impresoraSeleccionada={this.state.impresoraSeleccionada}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    usuarioId: state.user.usuarioId,
    empresaId: state.empresa.id,
    certificada: state.empresa.certificada,
    envios: state.empresa.envios,
    equipoMedico: state.empresa.equipoMedico,
    cargarXmlPrevio: state.empresa.cargarXmlPrevio,
    duplicarVentas: state.empresa.duplicarVentas,
    escuela: state.empresa.escuela,
    impresoraSeleccionada: state.empresa.impresoraSeleccionada,
    permisoAgregarVenta:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615ccb6bf30e81b54183cf70"
      )?.activado,
    permisoCancelarVenta:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6472d37f4b2da7c85c1a8cff"
      )?.activado,
    permisoEntregarInsumosVenta:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615ccbaff30e81b54183cf71"
      )?.activado,
    permisoPuntoVenta:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6750914f798d4e004368723f"
      )?.activado,
    permisoFacturaGlobal:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6750916e798d4e0043687240"
      )?.activado,
    permisoXmlPrevio:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "68a0b80d4319162f78ce641f"
      )?.activado,
    permisoFacturarVentas:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615ce36bf30e81b54183cfaf"
      )?.activado,
    permisoRegularizarInventarioVentas:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "696453cc71c0403da77f0b2b"
      )?.activado,
    permisoImportarVentasLibrosDigitales:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6ab9b55abc2e8e8899c085f1"
      )?.activado,
  };
};

export default connect(mapStateToProps, { cambiarImpresora })(Ventas);

